export default __webpack_public_path__ + "static/media/logo-jira-service-management.0575fe64.svg";